module.exports = __webpack_public_path__ + "static/media/Portrait.660a899f.jpeg";